import { render, staticRenderFns } from "./AuthorDetail.vue?vue&type=template&id=564d0f3a&scoped=true"
import script from "./AuthorDetail.vue?vue&type=script&lang=js"
export * from "./AuthorDetail.vue?vue&type=script&lang=js"
import style0 from "./AuthorDetail.vue?vue&type=style&index=0&id=564d0f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d0f3a",
  null
  
)

export default component.exports